// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__Llekh","alert":"SettungsInbox_alert__f9Ds6"};